<template>
  <div v-if="totalPages > 1" class="grid-x align-center">
    <div class="pagination cell small-12 medium-10 large-8">
      <button
        class="navigation -prev"
        @click="onClickPreviousPage"
        :class="{ '-disable': isInFirstPage }"
      >
        <span class="navigation-text">Previous</span>
      </button>

      <div class="pages">
        <button
          class="item"
          v-if="pages.length && pages[0].name !== 1"
          @click="onClickFirstPage"
        >
          1
        </button>
        <span class="item" v-if="pages.length && pages[0].name > 2">...</span>

        <button
          v-for="page in pages"
          :key="page.name"
          @click="onClickPage(page.name)"
          class="item"
          :class="{ '-current': page.isCurrent }"
        >
          {{ page.name }}
        </button>

        <span
          class="item"
          v-if="pages.length && pages[pages.length - 1].name < totalPages - 1"
          >...</span
        >

        <button
          v-if="pages.length && pages[pages.length - 1].name !== totalPages"
          @click="onClickLastPage"
          class="item"
        >
          {{ totalPages }}
        </button>
      </div>

      <button
        class="navigation -next"
        @click="onClickNextPage"
        :class="{ '-disable': isInLastPage }"
      >
        <span class="navigation-text">Next</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1;
      }
      // When on the last page
      if (this.currentPage === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons + 1;
      }
      // When in between
      return this.currentPage - 1;
    },
    pages() {
      const range = [];

      for (
        let i = this.startPage;
        i <=
        Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        i += 1
      ) {
        if (i != 0) {
          range.push({
            name: i,
            isCurrent: i === this.currentPage,
          });
        }
      }

      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    updatePage(page) {
      this.$emit("update:current-page", page);
    },
    onClickFirstPage() {
      this.updatePage(1);
    },
    onClickPreviousPage() {
      this.updatePage(this.currentPage - 1);
    },
    onClickPage(page) {
      this.updatePage(page);
    },
    onClickNextPage() {
      this.updatePage(this.currentPage + 1);
    },
    onClickLastPage() {
      this.updatePage(this.totalPages);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.pagination {
  display: flex;
  justify-content: space-between;
  margin-bottom: vw-relative(40);
}
.navigation {
  display: inline-flex;
  align-items: center;
  &.-disable {
    pointer-events: none;
    opacity: 0;
  }
  &-text {
    font: 600 16px/1 CenturyGothic;
    color: #6B2377;
    text-transform: uppercase;
    @include breakpoint(small only) {
      display: none;
    }
  }
  &:after,
  &:before {
    display: inline-block;
    width: 32px;
    height: 32px;
    background-color: #6B2377;
    border-radius: 50%;
    background-image: url("~@/assets/images/arrow.svg");
    background-position: center;
    background-size: 50% 50%;
    background-repeat: no-repeat;
    box-shadow: 0 2px 4px rgba(#000000, 0.23);
  }
  &.-prev:before {
    content: "";
    margin-right: 8px;
    transform: scaleX(-1);
  }
  &.-next:after {
    content: "";
    margin-left: 8px;
  }
}
.item {
  font: 600 16px/1 CenturyGothic;
  color: #6B2377;
  padding: 8px;
  &.-current {
    position: relative;
    pointer-events: none;
    &:after {
      position: absolute;
      display: block;
      content: "";
      left: 50%;
      transform: translateX(-50%);
      bottom: 4px;
      width: calc(100% - 16px);
      border-bottom: 2px solid #6B2377;
    }
  }
}
</style>
